import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration - Podmixr Labs Production
const firebaseConfig = {
  apiKey: "AIzaSyBrXrMC6ljTotFF6eD5vs_3FrRNr7L9CQ8",
  authDomain: "podmixr-labs.firebaseapp.com",
  projectId: "podmixr-labs",
  storageBucket: "podmixr-labs.firebasestorage.app",
  messagingSenderId: "428784468338",
  appId: "1:428784468338:web:2b8045787bb92b980a1deb",
  measurementId: "G-BG0YG0MXZY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
export default app;
